/*
 *This file provides Styles for Tooltip Component
 */

import styled from "styled-components/macro";
import { spacing, radius } from "../../Foundation";

export const TooltipWrapper = styled.div`
    .tooltip {
        background-color: white;
        color: black;
        min-width: auto;
        opacity: 1 !important;
        box-shadow: 0 10px 15px -3px rgba(23, 23, 28, 0.1), 0 4px 6px -2px rgba(23, 23, 28, 0.05);
        padding: ${spacing.spacing_8};
        border-radius: ${radius.radius_8};
        position: fixed !important;
    }

    .paragraph-styles {
        max-width: 250px;
    }

    p {
        margin: 0;
    }
`;

export const TooltipView = styled.div`
    .tooltip-heading,
    .tooltip-text {
        margin-bottom: 0;
        letter-spacing: 0.2;
        text-align: left;
        font-size: 14px;
    }

    .tooltip-heading {
        color: #4d4d4d;
        font-weight: 500;
        margin-bottom: ${spacing.spacing_4};
    }

    .tooltip-text {
        color: gray;
        font-weight: 400;
        overflow: auto;

        ::-webkit-scrollbar,
        ::-moz-scrollbar {
            display: none;
            -ms-overflow-style: none;
            appearance: none;
        }

        &:hover::-webkit-scrollbar {
            display: block;
        }
    }
`;

export const TooltipCloseView = styled.div`
    position: absolute;
    right: 0;
    top: 0;
`;
